import React, { useEffect, useState } from 'react';
import { Morph } from '../data/teaser';
import { usePaused } from '../hooks/usePlayback';
interface MorphStageProps {
  morph: Morph;
  heightClass?: string;
  /** Milliseconds each side is held before the cross-dissolve. */
  holdMs?: number;
}

/**
 * Shows the digitally planned attachment dissolving into the attachment that is
 * actually bonded, then back again — a short continuous loop.
 */
export function MorphStage({
  morph,
  heightClass = 'h-52',
  holdMs = 2200
}: MorphStageProps) {
  const [showActual, setShowActual] = useState(false);
  const paused = usePaused();
  useEffect(() => {
    if (paused) return;
    const interval = setInterval(() => setShowActual(prev => !prev), holdMs);
    return () => clearInterval(interval);
  }, [holdMs, paused]);
  return <figure className={`relative w-full overflow-hidden rounded-2xl border border-white/10 bg-black/30 ${heightClass}`} data-id="element-72" data-mp="3p29uoegi2y47">
      <img src={morph.planned} alt={morph.alt} className="absolute inset-0 h-full w-full object-cover transition-[opacity,transform] duration-[600ms] ease-out" style={{
      opacity: showActual ? 0 : 1,
      transform: showActual ? 'scale(1.04)' : 'scale(1)'
    }} data-id="element-73" data-mp="3k1c4pfp90zs5" />
      <img src={morph.actual} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover transition-[opacity,transform] duration-[600ms] ease-out" style={{
      opacity: showActual ? 1 : 0,
      transform: showActual ? 'scale(1)' : 'scale(1.04)'
    }} data-id="element-74" data-mp="i0li3o2ymc8n" />

      <figcaption className="absolute inset-x-0 bottom-0 flex items-center justify-between bg-gradient-to-t from-black/70 to-transparent px-3.5 pb-3 pt-8" data-id="element-75" data-mp="3vdx4fkg0hmth">
        <span className={`font-body text-[11px] font-semibold uppercase tracking-[0.18em] transition-colors duration-300 ${showActual ? 'text-white/45' : 'text-solventum-primary'}`} data-id="element-76" data-mp="44zvfnk784je">
          {showActual ? morph.actualLabel : morph.plannedLabel}
        </span>
        <span className="flex gap-1.5" aria-hidden="true" data-id="element-77" data-mp="37bigu4ipv7j5">
          <span className={`h-1 rounded-full transition-all duration-300 ${showActual ? 'w-2 bg-white/30' : 'w-5 bg-solventum-primary'}`} data-id="element-78" data-mp="32i779vmiscnj" />
          <span className={`h-1 rounded-full transition-all duration-300 ${showActual ? 'w-5 bg-solventum-primary' : 'w-2 bg-white/30'}`} data-id="element-79" data-mp="2sluceuf8nsr7" />
        </span>
      </figcaption>
    </figure>;
}